import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMail, FiLock, FiAlertCircle } from 'react-icons/fi';
import { Button, Input } from '../../components/UI';
import { loginAdmin } from '../../config/firebase';
import styles from './Login.module.css';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await loginAdmin(email, password);
      navigate('/');
    } catch (err) {
      console.error('Login error:', err);
      if (err.message.includes('Unauthorized')) {
        setError('This email is not authorized as admin');
      } else if (err.code === 'auth/invalid-credential') {
        setError('Invalid email or password');
      } else if (err.code === 'auth/too-many-requests') {
        setError('Too many failed attempts. Please try again later.');
      } else {
        setError('Failed to login. Please check your credentials.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.logo}>
            <img src="/dierend-logo.png" alt="Dierend" />
          </div>
          <h1 className={styles.title}>Dierend Admin</h1>
          <p className={styles.subtitle}>Sign in to access the admin dashboard</p>
        </div>

        {error && (
          <div className={styles.error}>
            <FiAlertCircle />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className={styles.form}>
          <Input
            label="Email"
            type="email"
            placeholder="admin@dierend.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon={FiMail}
            autoComplete="username"
            required
          />

          <Input
            label="Password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon={FiLock}
            autoComplete="current-password"
            required
          />

          <Button
            type="submit"
            fullWidth
            loading={loading}
            disabled={!email || !password}
          >
            Sign In
          </Button>
        </form>

        <div className={styles.footer}>
          <p>Admin access is restricted to authorized emails only.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
